'use strict';

const Gift = {
  init(payload, done) {
    this.cookieDomain =
      payload && payload.giftButton && payload.giftButton.cookieDomain;
    this.bindGiftButton();
    done();
  },

  bindGiftButton() {
    const $selected = document.querySelector(
      '.m-option-b.inline-list input:checked'
    );
    const $gift_button = document.querySelectorAll('.gift-button');

    if ($gift_button.length > 0) {
      $gift_button.forEach($btn => {
        if ($selected) {
          $btn.href = `${$selected.value}&gift=true`;
        }

        $btn.addEventListener('click', e => {
          this.createCookie();

          if (window.BuyButton && window.BuyButton.eventBus) {
            e.preventDefault();
            window.BuyButton.eventBus.go('buy_button_clicked', e);
          }
        });
      });
    }
  },

  createCookie() {
    window.Cookie.set('modalForGiftOnLoad', 'true', 60, this.cookieDomain);
    this.cookieCreated = true;
    return this.cookieCreated;
  },

  removeCookie() {
    window.Cookie.unset('modalForGiftOnLoad', this.cookieDomain);
    this.cookieCreated = false;
    return this.cookieCreated;
  },
};

module.exports = Gift;
